exports = module.exports = require("./../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".style__container___1U3A8{\r\n  display: -webkit-box;\r\n  display: -ms-flexbox;\r\n  display: flex;\r\n}\r\n", "", {"version":3,"sources":["/./components/GeneralInfo/style.css"],"names":[],"mappings":"AAAA;EACE,qBAAc;EAAd,qBAAc;EAAd,cAAc;CACf","file":"style.css","sourcesContent":[".container{\r\n  display: flex;\r\n}\r\n"],"sourceRoot":"webpack://"}]);

// exports
exports.locals = {
	"container": "style__container___1U3A8"
};


/*****************
 ** WEBPACK FOOTER
 ** ../~/css-loader?modules&sourceMap&importLoaders=1&localIdentName=[name]__[local]___[hash:base64:5]!../~/postcss-loader!./components/GeneralInfo/style.css
 ** module id = 976
 ** module chunks = 1
 **/


/*****************
 ** WEBPACK FOOTER
 ** ../~/css-loader?modules&sourceMap&importLoaders=1&localIdentName=[name]__[local]___[hash:base64:5]!../~/postcss-loader!./components/GeneralInfo/style.css
 ** module id = 976
 ** module chunks = 1
 **/